export default __webpack_public_path__ + "static/flyer2@2x-3a8204897885252b1d6c1f390039e5e3.jpg";